import { IJsonQuery } from './types/jsonQuery';
import * as R from 'ramda';

import { NonEmptyArray } from './types/common';
import { EFacilityType } from './types';
import { resetTerms, setTerm } from './helpers';

export function setBathTypes(jsonQuery: IJsonQuery) {
  return (facilityTypes: NonEmptyArray<EFacilityType> | null): IJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    nextJsonQuery = resetTerms(['bath', 'shower'])(nextJsonQuery);

    if (facilityTypes) {
      if (facilityTypes.includes(EFacilityType.Bath)) {
        nextJsonQuery = setTerm('bath')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Shower)) {
        nextJsonQuery = setTerm('shower')(nextJsonQuery)(true);
      }
    }

    return nextJsonQuery;
  };
}
